<template>
    <my-popconfirm
        :title="title"
        :placement="placement"
        @onConfirm="onConfirm"
    >
        <ux-button type="danger" text slot="reference">{{ text }}</ux-button>
    </my-popconfirm>
</template>
<script>

import myPopconfirm from '@c/myPopconfirm/myPopconfirm';
export default {
  name: 'DelRulePop',
  components: {
    myPopconfirm
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    text: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onConfirm() {
      this.$emit('on-confirm');
    }
  }
};
</script>
